<script setup lang="ts">
import {
  Contexts,
  NamedBindings,
  TranslationService,
  getContainer,
} from '@dandelion/core';
import UserInfo from './UserInfo.vue';
import CentrePreferencesComponent from './CentrePreferences/CentrePreferencesComponent.vue';
import UserPreferencesComponent from './UserPreferences/UserPreferencesComponent.vue';

const ts = getContainer(Contexts.DEFAULT).get(
  NamedBindings.TranslationService
) as TranslationService;

const menuItems:any = [
  // { title: 'Home', path: '/home', icon: 'home-outline' },
  //{ title: 'Patient List', path: '/', icon: 'file-tray-full-outline' },
];
</script>

<template>
  <header class="navbar top-0 z-4 shadow-md navbar-bg">
    <div id="prosafe-banner">
        <img width="50" src="/src/assets/logogivititrasp.png" />
      <span class="text-2xl font-semibold ml-2" v-html="'Prosafe'"></span>
    </div>
    <div id="nav-buttons-container" class="flex ml-auto">
      <template v-for="item in menuItems">
        <button
          id="patient-list-link"
          v-if="$router.currentRoute.value.path != item.path"
        >
          <RouterLink :to="item.path">
            <ion-icon :name="item.icon"></ion-icon>
            <span v-html="ts.t(item.title)"></span>
          </RouterLink>
        </button>
      </template>
      <!--<DictionaryComponent></DictionaryComponent>-->
      <UserPreferencesComponent />
      <CentrePreferencesComponent />
    </div>
    <UserInfo></UserInfo>
  </header>
</template>

<style>
#prosafe-banner a {
  display: flex;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgb(0 0 0 / 20%);
}

#nav-buttons-container {
  gap: 8px;
}

#prosafe-banner a,
#nav-buttons-container .dicbutton,
#nav-buttons-container #user-preferences-dialog-btn,
#nav-buttons-container #centre-preferences-dialog-btn {
  min-width: 3rem;
  border-radius: 1rem;
}

#nav-buttons-container button {
  font-size: 18px;
  padding: 0.75rem;
}

.navbar-bg {
  background-color: #388087;
  color: white;
  position: sticky;
  top: 0;
  z-index: 4;
  width: 100%;
}

.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow-y: auto;
  top: 50%;
  left: 0;
}

#patient-list-link a {
  display: flex;
  align-items: center;
  gap: 6px;
}

#patient-list-link a ion-icon {
  font-size: 1.25rem;
}

#patient-list-link span {
  margin-bottom: 2px;
}
</style>
